import { FC, ReactElement } from 'react'
import cn from 'classnames'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import classes from './index.module.css'

type TaskTrackerPermissionTooltipProps = {
  title: string | null | undefined
  children: ReactElement
  block?: boolean
  gridCell?: boolean
  contentsLayout?: boolean
  className?: string
}

const TaskTrackerPermissionTooltip: FC<TaskTrackerPermissionTooltipProps> = ({
  title,
  children,
  block = false,
  gridCell = false,
  contentsLayout = false,
  className,
}) => {
  if (!title) return children

  return (
    <TooltipWrapper
      title={title}
      placement="top"
      color="var(--task-tracker-surface)"
      overlayClassName={classes.tooltipOverlay}
    >
      <span
        className={cn(
          contentsLayout
            ? classes.wrapContents
            : gridCell
              ? classes.wrapGridCell
              : block
                ? classes.wrapBlock
                : classes.wrapInlineBlock,
          className,
        )}
      >
        {children}
      </span>
    </TooltipWrapper>
  )
}

export default TaskTrackerPermissionTooltip
